import React from "react";
import { IonSpinner } from "@ionic/react";

type OneLoaderProps = {
  loadingText: string;
};
const OneLoader: React.FC<OneLoaderProps> = ({ loadingText }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 5,
        padding: 10,
      }}
    >
      <IonSpinner name="crescent"></IonSpinner>
      <p
        className="ion-no-margin"
        style={{ fontSize: "var(--one-font-size-8)" }}
      >
        {loadingText}
      </p>
    </div>
  );
};

export default OneLoader;
